import TopHeader from './components/TopHeader'
import './styles.scss'

const HeaderMain = () => {
  return (
    <div className="header-main">
      <TopHeader />
    </div>
  )
}

export default HeaderMain
